import gql from 'graphql-tag';

import userFragment from './user-fragment';

export default gql`
  mutation resetPasswordRequestUserMutation($email: String!) {
    resetPasswordRequestUserMutation(email: $email) {
      title
      message
      record {
        ...UserFragment
      }
    }
  }
  ${userFragment}
`;
